import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Footer } from "@climatepartner/components";
const FooterSlot = ({ slots }) => {
    if (slots?.footer) {
        return _jsx(_Fragment, { children: slots.footer });
    }
    return _jsx(Footer, {});
};
export default FooterSlot;
//# sourceMappingURL=FooterSlot.js.map